module.exports = __webpack_public_path__ + "img/img2.9310f3ae.png";